export default __webpack_public_path__ + "static/media/nykaa.2201c5e0.jpg";